import {Map} from 'immutable';

/** encode data to url query string for methods that don't support body
 * @param {object} data data to encode
 * @return {string} encoded query string
 */
export default function toQueryString(data) {
    if (!data || Object.keys(data)?.length === 0) {
        return '';
    }
    if (typeof data === 'string') {
        return data;
    }
    if (typeof data !== 'object') {
        console.error(`Unsupported data of type ${typeof data} for query strings`);
        return null;
    }
    // immutable Map used so object can be treated as associative array
    return (new Map(data)).map((value, param) => {
        // if value is array, add multiple params with same name and [] at the end
        if (Array.isArray(value)) {
            return value.map((value) => {
                return encodeURIComponent(param) + '[]=' + encodeURIComponent(value);
            }).join('&');
        }

        return encodeURIComponent(param) + '=' + encodeURIComponent(value);
    }).join('&');
}
